import React, { useState } from "react";
import { Bell, BellOff } from "lucide-react";
import { toast } from "react-toastify";
import communityService from "../../../services/communityService";
import "./FollowThreadButton.css";

const FollowThreadButton = ({
  communityId,
  threadId,
  initialIsFollowing = false,
  compact = false,
  onFollowChange,
}) => {
  const [isFollowing, setIsFollowing] = useState(initialIsFollowing);
  const [loading, setLoading] = useState(false);

  const handleFollow = async (e) => {
    e.stopPropagation();

    if (loading) return;

    // Optimistic update
    const previousState = isFollowing;
    setIsFollowing(!isFollowing);

    try {
      setLoading(true);

      const response = await communityService.followThread(
        communityId,
        threadId
      );

      if (response.success) {
        const newFollowState = response.data.isFollowing;
        setIsFollowing(newFollowState);

        if (onFollowChange) {
          onFollowChange(newFollowState);
        }

        toast.success(
          newFollowState
            ? "You'll receive notifications for new replies"
            : "Stopped following discussion"
        );
      } else {
        throw new Error("Failed to update follow status");
      }
    } catch (error) {
// Revert on error
      setIsFollowing(previousState);
      toast.error(error.message || "Failed to update follow status");
    } finally {
      setLoading(false);
    }
  };

  if (compact) {
    return (
      <button
        className={`follow-thread-btn-compact ${
          isFollowing ? "following" : ""
        } ${loading ? "loading" : ""}`}
        onClick={handleFollow}
        disabled={loading}
        title={isFollowing ? "Stop following" : "Follow for notifications"}
      >
        {loading ? (
          <div className="follow-spinner-small"></div>
        ) : isFollowing ? (
          <BellOff size={14} />
        ) : (
          <Bell size={14} />
        )}
      </button>
    );
  }

  return (
    <button
      className={`follow-thread-btn ${isFollowing ? "following" : ""} ${
        loading ? "loading" : ""
      }`}
      onClick={handleFollow}
      disabled={loading}
      title={isFollowing ? "Stop following" : "Follow for notifications"}
    >
      {loading ? (
        <>
          <div className="follow-spinner"></div>
          <span>Loading...</span>
        </>
      ) : isFollowing ? (
        <>
          <BellOff size={16} />
          <span>Following</span>
        </>
      ) : (
        <>
          <Bell size={16} />
          <span>Follow</span>
        </>
      )}
    </button>
  );
};

export default FollowThreadButton;
